import React, { useEffect, useState } from 'react'
import {
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CCardBody,
  CCard,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormLabel,
} from '@coreui/react'
import PatientSuperBillData from '../../services/general/patientSuperBill.api'
import PatientFinalNote from './PatientFinalNote'
import { CalendarDays, Files } from 'lucide-react'
import PatientOrdersCRUD from '../../services/general/patientOrders.api'
import Carder from '../../components/shared/Carder'
import { usePDF } from 'react-to-pdf'
import PatientNoteViewInModal from './PatientNoteViewInModal'
import Orderstab from './Orderstab'
import Accordions from '../../components/shared/Accordians'
import SaveExtra from '../../services/general/saveExtraData.api'
import ProviderLsPatientNoteView from './ProviderLsPatientNoteView'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderLsSuperBillComponent = ({
  submitNotes,
  setDataId,
  statusPatientNote,
  showCreateTaskInOrder = true,
  showMedicationLikeApp,
  showHrsInTreatment,
  showTreatmentAsAccordion,
  setModalVisible,
  formData,
  diagnosis,
  allLabs,
  patientID,
  diagnosisCode,
  selectedRisks,
  setSelectedRisks,
  MasterDiagnosisData,
  noteStructureRef,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  patientData,
  patientTreatments,
  hospitalRecords,
  patientDiagnosis,
  diagnosisAddedPinger,
  setHospitalRecords,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  imagingTypeList,
  selectedDifferentialDiagnosis,
  noteID,
  patientDBData,
}) => {
  const { getAddedEndumen } = useIndexedDB()
  const [currentTab, setCurrentTab] = useState(0)
  const [superBill, setSuperBill] = useState(null)
  const [patientOrder, setPatientOrders] = useState([])
  const [ordersData, setOrdersData] = useState([])
  const [showOrderPopUp, setShowOrderPopUp] = useState(false)
  const [file, setFile] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [addendum, setAddendum] = useState([])

  const showDataIfNoteIsFollowUp = statusPatientNote && statusPatientNote === 'Follow Up' ? true : false

  console.log(showCreateTaskInOrder, patientDBData, 'showCreateTaskInOrder')
  const formatDate = (dateString) => {
    if (!dateString) return '' // Handle undefined/null cases
    const [day, month, year] = dateString.split('-')
    return `${month}-${day}-${year}`
  }

  // const fetchOrders = async () => {
  //   try {
  //     let formattedData
  //
  //     formattedData = await PatientOrdersCRUD('Get', '', patientID, '', '', '', '')

  //     formattedData = JSON.parse(formattedData.d)
  //     formattedData = formattedData?.Data || []

  //     if (formattedData) {
  //       formattedData = formattedData.map((item, idx) => {
  //         return {
  //           ...item,
  //           medication: item.medication == '' ? [] : JSON.parse(item.medication),
  //           // imaging: item.imaging.length > 0 ? JSON.parse(item?.imaging) : {},
  //           // medication: item.medication ? JSON.parse(item.medication) : {},
  //           // labs: item.labs.length > 0 ? JSON.parse(item?.labs) : {}
  //         }
  //       })
  //     }

  //     setOrdersData(formattedData)
  //   } catch (error) {
  //     console.log('error in order data', error)
  //   }
  // }
  const fetchOrders = async () => {
    try {
      let formattedData
      formattedData = patientDBData?.ordersData
      console.log('orderdata ', formattedData)
      setOrdersData(formattedData)
    } catch (error) {
      console.log('error in order data', error)
    }
  }

  const getSuperBillData = async () => {
    // let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
    // data = JSON.parse(data?.d)?.Data || []
    let data = patientDBData?.patientSuperBill
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
    }

    setSuperBill(data)
    // }
    // console.log("get data ======>", getData, JSON.parse(getData?.d))
  }

  const filteDiagnosisCode = (codes) => {
    if (!Array.isArray(codes)) return ''

    let result = MasterDiagnosisData.filter((item) => codes?.includes(item.id))
      .map((item) => item.Name)
      .join(', ')

    return result || ''
  }

  useEffect(() => {
    getSuperBillData()
    fetchOrders()
  }, [])

  // Pdf part
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' })
  const [capturing, setCapturing] = useState(false)
  const handleDownload = async () => {
    setCapturing(true)
    await toPDF({ page: { margin: 'Margin.SMALL' } })
    setCapturing(false)
  }

  const handleScript = (file) => {
    console.log('file==>', file)
    setFile(file)
    setShowOrderPopUp(true)
  }

  const fetchAddendumData = async () => {
    try {
      // let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      // data = JSON.parse(data?.d)?.Data || []
      let data = await getAddedEndumen()

      data = data.map((item) => JSON.parse(item?.JsonData))

      data = data.reverse() // latest first

      const currentNoteID = noteID.toString()
      const noteIDNum = parseInt(noteID, 10)

      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              console.log(`Found exact match: patient ${patientID}, noteID ${currentNoteID}`)
              return item[patientID][currentNoteID]
            }

            // if (previousNoteID && item[patientID][previousNoteID]) {
            //     console.log(`Found previous note: patient ${patientID}, noteID ${previousNoteID}`);
            //     return item[patientID][previousNoteID];
            // }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)

      if (result) {
        setAddendum(result)
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
  }

  useEffect(() => {
    fetchAddendumData()
  }, [])

  console.log('orders data ', ordersData)

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  return (
    <>
      <div style={{}}>
        {role == 'provider' ? (
          <div className="  p-2" style={{ background: '#282828' }}>
            <div className="d-flex gap-3">
              <button
                className="btn"
                style={{
                  backgroundColor: currentTab === 0 ? '#4363F2' : 'transparent',
                  color: currentTab === 0 ? '#fff' : '#adb5bd',
                  borderRadius: '20px',
                  padding: '6px 16px',
                  border: 'none',
                }}
                onClick={() => setCurrentTab(0)}
              >
                Note
              </button>

              <button
                className="btn"
                style={{
                  backgroundColor: currentTab === 1 ? '#4363F2' : 'transparent',
                  color: currentTab === 1 ? '#fff' : '#adb5bd',
                  borderRadius: '20px',
                  padding: '6px 16px',
                  border: 'none',
                }}
                onClick={() => setCurrentTab(1)}
              >
                Super Bill
              </button>

              <button
                className="btn"
                style={{
                  backgroundColor: currentTab === 2 ? '#4363F2' : 'transparent',
                  color: currentTab === 2 ? '#fff' : '#adb5bd',
                  borderRadius: '20px',
                  padding: '6px 16px',
                  border: 'none',
                }}
                onClick={() => setCurrentTab(2)}
              >
                Order
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-transparent patient-theme-modal">
            <CNav variant="pills" role="tablist" className="justify-content-start">
              <CNavItem>
                <CNavLink
                  active={currentTab === 0}
                  onClick={() => {
                    setCurrentTab(0)
                  }}
                >
                  Note
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  active={currentTab === 1}
                  onClick={() => {
                    setCurrentTab(1)
                  }}
                >
                  Super Bill
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  active={currentTab === 2}
                  onClick={() => {
                    setCurrentTab(2)
                  }}
                >
                  Order
                </CNavLink>
              </CNavItem>
            </CNav>
          </div>
        )}

        <div>
          <CTabContent className="appointment-patient-info-theme bg-transparent-override patient-theme-modal">
            <CTabPane className="accordion-dark" style={{ height: '800px', maxHeight: '800px', overflowY: 'auto' }} visible={currentTab === 0}>
              <div
                ref={targetRef}
                className=""
                style={{
                  padding: '11px',

                  // border:capturing ? "" : "0.51px solid rgba(44, 27, 27, 0.14)"
                  // maxHeight: capturing ? 'none' : '50vh',
                  // overflow: capturing ? 'visible' : 'auto',
                }}
              >
                <ProviderLsPatientNoteView
                  setDataId={setDataId}
                  // showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                  showDataIfNoteIsFollowUp={patientData?.Status === 'Follow Up' ? true : false}
                  showTreatmentAsAccordion={showTreatmentAsAccordion}
                  showHrsInTreatment={showHrsInTreatment}
                  showMedicationLikeApp={showMedicationLikeApp}
                  diagnosisCode={diagnosisCode}
                  noteStructureRef={noteStructureRef}
                  selectedRisks={selectedRisks}
                  setSelectedRisks={setSelectedRisks}
                  selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                  hospitalRecords={hospitalRecords}
                  setHospitalRecords={setHospitalRecords}
                  medication={medication}
                  setMedication={setMedication}
                  patientID={patientID}
                  patientTreatments={patientTreatments}
                  newImagingAdded={newImagingAdded}
                  newLabsAdded={newLabsAdded}
                  newmedsAdded={newmedsAdded}
                  diagnosisAddedPinger={diagnosisAddedPinger}
                  allergies={allergies}
                  setAllergies={setAllergies}
                  patientDiagnosis={patientDiagnosis}
                  MasterDiagnosisData={MasterDiagnosisData}
                  imagingTypeList={imagingTypeList}
                  imaging={imaging}
                  setImaging={setImaging}
                  activeTab={activeTab}
                  patientData={patientData}
                  patientSidebarActiveTab={patientSidebarActiveTab}
                  personalHistory={personalHistory}
                  setPersonalHistory={setPersonalHistory}
                  allLabs={allLabs}
                  noteShow={false}
                  noteID={noteID}
                  addendumData={addendum}
                  patientDBData={patientDBData}
                  onlyShowHTmlService={false}
                ></ProviderLsPatientNoteView>
              </div>
            </CTabPane>
            {/* <CTabPane visible={currentTab === 1} className={` ${role == 'provider' ? 'accordion-dark' : ' '}`} style={{ height: '400px', maxHeight: '600px', overflow: 'auto' }}>
              <CAccordion activeItemKey={2} className="homeAccordion">
                {superBill &&
                  superBill?.map((data, index) => {
                    return (
                      <CAccordionItem itemKey={index} className="rounded -2 overflow-hidden border my-2">
                        <CAccordionHeader className="rounded-top" style={{}}>
                          {' '}
                          <CalendarDays size={16} /> <span className="ms-1"> {new Date(data.Data.PDate).toLocaleDateString('en-US')}</span>
                        </CAccordionHeader>
                        <CAccordionBody className="rounded-bottom p-3">
                          <div className="  p-3 rounded">
                            <div className="container">
                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Facility Name:</strong>
                                </div>
                                <div className="col-8">{data.Data.facilityName}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Facility Type:</strong>
                                </div>
                                <div className="col-8">{data.Data.facilityType}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Patient Type:</strong>
                                </div>
                                <div className="col-8">{data.Data.patientType || 'N/A'}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Follow Up Time:</strong>
                                </div>
                                <div className="col-8">{data.Data.followUpTime}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Reason:</strong>
                                </div>
                                <div className="col-8">{data.Data.reason || 'N/A'}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>CPT Code:</strong>
                                </div>
                                <div className="col-8">{data.Data.cptCode}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>ICD Codes:</strong>
                                </div>
                                <div className="col-8">
                                  {data.Data.icdCodes.split(', ').map((code, index) => (
                                    <span key={index} className="me-2">
                                      {code}
                                    </span>
                                  ))}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Modifier:</strong>
                                </div>
                                <div className="col-8">{data.Data.modifier}</div>
                              </div>
                            </div>
                          </div>
                        </CAccordionBody>
                      </CAccordionItem>
                    )
                  })}
              </CAccordion>
            </CTabPane> */}

            <CTabPane visible={currentTab === 1} className="accordion-dark" style={{ height: '600px', maxHeight: '600px', overflow: 'auto' }}>
              <CAccordion activeItemKey={2} className="homeAccordion">
                {superBill && superBill.length > 0 ? (
                  superBill?.map((data, index) => {
                    return (
                      <CAccordionItem itemKey={index} className="rounded -2 overflow-hidden border my-2">
                        <CAccordionHeader className="rounded-top" style={{}}>
                          {' '}
                          <CalendarDays size={16} /> <span className="ms-1"> {new Date(data.Data.PDate).toLocaleDateString('en-US')}</span>
                        </CAccordionHeader>
                        <CAccordionBody className="rounded-bottom p-3">
                          <div className="  p-3 rounded">
                            <div className="container">
                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Facility Name:</strong>
                                </div>
                                <div className="col-8">{data.Data.facilityName}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Facility Type:</strong>
                                </div>
                                <div className="col-8">{data.Data.facilityType}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Patient Type:</strong>
                                </div>
                                <div className="col-8">{data.Data.patientType || 'N/A'}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Follow Up Time:</strong>
                                </div>
                                <div className="col-8">{data.Data.followUpTime}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Reason:</strong>
                                </div>
                                <div className="col-8">{data.Data.reason || 'N/A'}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>CPT Code:</strong>
                                </div>
                                <div className="col-8">{data.Data.cptCode}</div>
                              </div>

                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>ICD Codes:</strong>
                                </div>
                                <div className="col-8">
                                  {data.Data.icdCodes.split(', ').map((code, index) => (
                                    <span key={index} className="me-2">
                                      {code}
                                    </span>
                                  ))}
                                </div>
                              </div>
                              <div className="row mb-2">
                                <div className="col-3">
                                  <strong>Modifier:</strong>
                                </div>
                                <div className="col-8">{data.Data.modifier}</div>
                              </div>
                            </div>
                          </div>
                        </CAccordionBody>
                      </CAccordionItem>
                    )
                  })
                ) : (
                  <div className="d-flex align-items-center justify-content-center" style={{ padding: '20px' }}>
                    <p
                      style={{
                        color: 'white', // Ensures the text is white
                        fontSize: '14px',
                        textAlign: 'center',
                      }}
                    >
                      No Super Bill data available for this patient.
                    </p>
                  </div>
                )}
              </CAccordion>
            </CTabPane>

            <CTabPane visible={currentTab === 2} className="accordion-dark">
              <CAccordion className="homeAccordion">
                {ordersData?.map((data, index) => {
                  const currentOrder = data?.medication
                  const formattedDate = () => {
                    const parts = data?.date?.split('-')
                    console.log(parts, 'parts')
                    if (!parts || parts.length !== 3) return ''
                    const [month, day, year] = parts
                    const date = new Date(`${year}-${month}-${day}`)
                    return new Intl.DateTimeFormat('en-US', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    }).format(date)
                  }

                  return (
                    <CAccordionItem itemKey={index} className="rounded -2 overflow-hidden border my-2">
                      <CAccordionHeader className="rounded-top w-100" style={{}}>
                        <div className="d-flex align-items-center w-100 justify-content-between">
                          <div className="d-flex align-items-center justify-content-center gap-2">
                            <div className="d-flex align-items-center">
                              <CalendarDays size={16} /> <span className="ms-1">{formattedDate()}</span>
                            </div>
                            <div>Diagnosis:{data?.medication?.diagnosis}</div>
                          </div>

                          <div className="" style={{ paddingRight: '20px' }}>
                            {showCreateTaskInOrder && (
                              <CButton
                                style={{
                                  backgroundColor: '#4363F2',
                                  border: 'none',
                                  color: 'white',
                                  borderRadius: '6px',
                                  padding: '8px 20px',
                                }}
                                onClick={(event) => {
                                  event.stopPropagation()
                                  event.preventDefault()

                                  const taskData = {
                                    ...(patientData || {}),
                                    orderId: data?.id,
                                    description: `
                                     ${data?.medication?.medication?.length ? `${data.medication.medication.length} medication${data.medication.medication.length > 1 ? 's' : ''} ` : ''} ${
                                      data?.imaging?.imagingTypes?.length ? `${data.imaging.imagingTypes.length} imaging${data.imaging.imagingTypes.length > 1 ? 's' : ''} ` : ''
                                    } ${data?.labs?.labs?.length ? `${data.labs.labs.length} lab${data.labs.labs.length > 1 ? 's' : ''} ` : ''}
                                                                    `.trim(),
                                  }

                                  localStorage.setItem('newTask', JSON.stringify(taskData))

                                  window.location.href = '/home/kanban'
                                }}
                              >
                                Create Task
                              </CButton>
                            )}
                          </div>
                        </div>
                      </CAccordionHeader>
                      <CAccordionBody className="rounded-bottom p-3">
                        <div className="card shadow-sm  " style={{ background: role == 'provider' ? 'accordion-dark' : '' }}>
                          <div className="card-body">
                            {/* Imaging */}
                            {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Imaging</p>
                              <ul className="p-0 m-2">
  {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => {
    const type = imagingItem?.type
    const reason = imagingItem?.reason
    const code = imagingItem?.code

    return (
      <li className="p-0 m-0" key={iIdx}>
        {type  && (
          <div>
            {type}

            {imagingItem?.script?.length > 0 && (
              <span
                className="mb-1 mx-2"
                style={{ cursor: 'pointer' }}
                onClick={() => handleScript(imagingItem.script)}
              >
                <Files size={14} />
              </span>
            )}
          </div>
        )}

        {reason && (
          <div className="ms-3">
            Reason: {reason}
          </div>
        )}

        
      </li>
    )
  })}
</ul>
                              </div>
                            )}

                            {/* Labs */}
                            {currentOrder?.lab?.labs?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Labs</p>
                                <ul>
                                  {currentOrder.lab.labs.map((labItem, lIdx) => (
                                    <li className="p-0 m-0" key={lIdx}>
                                      {labItem?.lab}
                                      {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                      <span
                                        className="mb-1 mx-2"
                                        onClick={() => {
                                          handleScript(labItem?.script)
                                        }}
                                      >
                                        <Files size={14} />
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* Medications */}
                            {currentOrder?.medication?.medication?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Medications</p>
                                <ul>
                                  {currentOrder.medication.medication.map((medItem, mIdx) => (
                                    <li className="p-0 m-0" key={mIdx}>
                                      {medItem?.name} {medItem?.dosage} {medItem?.route}
                                      {medItem?.frequency && ` ${medItem.frequency}`}
                                      {medItem?.reason && ` - ${medItem.reason}`}
                                      <span
                                        className="mb-1 mx-2"
                                        onClick={() => {
                                          handleScript(medItem?.script)
                                        }}
                                      >
                                        <Files size={14} />
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* Miscellaneous */}
                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                <ul>
                                  {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                    <li className="p-0 m-0" key={xIdx}>
                                      {miscItem}
                                      <span
                                        className="mb-1 mx-2"
                                        onClick={() => {
                                          handleScript(miscItem?.script)
                                        }}
                                      >
                                        <Files size={14} />
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </CAccordionBody>
                    </CAccordionItem>
                  )
                })}

                {ordersData.length === 0 && (
                  <div className="d-flex align-items-center justify-content-center" style={{ padding: '20px' }}>
                    <p style={{ color: 'white' }}>No Orders Available </p>
                  </div>
                )}
              </CAccordion>
            </CTabPane>
            <CTabPane visible={currentTab === 3} className="accordion-dark" style={{ height: '800px', maxHeight: '800px', overflowY: 'auto' }}>
              <div className="p-3 bg-white rounded">
                {addendum && addendum.orders && addendum.orders.length > 0 ? (
                  addendum.orders.map((item, idx) => {
                    const currentOrder = item
                    return (
                      <div key={idx} className="mb-3">
                        <div className="card shadow-sm bg-secondary">
                          <div className="card-body">
                            {/* Date */}
                            <div className="">
                              <div>
                                <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                {(() => {
                                  const parts = addendum?.syncDate.split('-')
                                  if (!parts || parts.length !== 3) return ''
                                  const [month, day, year] = parts
                                  const date = new Date(`${year}-${month}-${day}`)
                                  return new Intl.DateTimeFormat('en-US', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  }).format(date)
                                })()}
                              </div>
                              {currentOrder?.diagnosis && (
                                <p className="mb-1" style={{ marginTop: '-8px' }}>
                                  <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                </p>
                              )}
                            </div>

                            {/* Medications */}
                            {currentOrder?.medication?.medication?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Medications:</p>
                                <ol>
                                  {currentOrder.medication.medication.map((medItem, mIdx) => (
                                    <li className="p-0 m-0" key={mIdx}>
                                      {medItem?.name} {medItem?.dosage} {medItem?.route} {medItem?.frequency}
                                      {medItem?.reason && ` - ${medItem.reason}`}
                                    </li>
                                  ))}
                                </ol>
                              </div>
                            )}

                            {/* Labs */}
                            {currentOrder?.lab?.labs?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Labs:</p>
                                <ol>
                                  {currentOrder.lab.labs.map((labItem, lIdx) => (
                                    <li className="p-0 m-0" key={lIdx}>
                                      {labItem?.lab}
                                      {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                    </li>
                                  ))}
                                </ol>
                              </div>
                            )}

                            {/* Imaging */}
                            {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Imaging:</p>
                                <ol>
                                  {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                                    <li className="p-0 m-0" key={iIdx}>
                                      {imagingItem?.type}
                                    </li>
                                  ))}
                                </ol>
                              </div>
                            )}

                            {/* Miscellaneous */}
                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Miscellaneous:</p>
                                <ol>
                                  {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                    <li className="p-0 m-0" key={xIdx}>
                                      {miscItem}
                                    </li>
                                  ))}
                                </ol>
                              </div>
                            )}

                            {/* POAC */}
                            <div className="mb-2">
                              <p className="text-secondary fw-bold mb-1">POAC:</p>
                              <ol>
                                <p className="p-0 m-0">{addendum?.poac?.[0]?.poacData?.content}</p>
                              </ol>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="text-center text-muted py-3">No addendum available.</div>
                )}
              </div>
            </CTabPane>
          </CTabContent>
          <CModal size="md" backdrop="static" visible={showOrderPopUp} onClose={() => setShowOrderPopUp(false)}>
            <CModalHeader
              style={{
                backgroundColor: '#191919',
                borderBottom: '1px solid gray',
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                borderRadius: '10px  10px 0 0',
              }}
            >
              <CModalTitle className="text-white">Order Script</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ height: '300px', overflow: 'auto', backgroundColor: '#191919' }}>
              <div className="d-flex flex-wrap gap-3">
                {file?.map((fileUrl, fileIdx) => {
                  const extension = fileUrl.split('.').pop()?.toLowerCase()

                  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
                  const isVideo = ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
                  const isDocument = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)

                  return (
                    <div key={fileIdx} className="d-flex flex-column gap-2 align-items-center">
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="shadow rounded p-2 position-relative d-block"
                        style={{
                          width: '100px',
                          height: '100px',
                          overflow: 'hidden',
                          borderRadius: '8px',
                          cursor: 'pointer',

                          textDecoration: 'none',
                        }}
                      >
                        {isVideo ? (
                          <video
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '8px',
                            }}
                            controls
                          >
                            <source src={fileUrl} type="video/mp4" />
                          </video>
                        ) : isImage ? (
                          <img
                            src={fileUrl}
                            alt="Uploaded"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '8px',
                            }}
                          />
                        ) : isDocument ? (
                          <iframe
                            src={fileUrl}
                            title="Document Viewer"
                            style={{
                              width: '100%',
                              height: '100%',
                              border: 'none',
                              borderRadius: '8px',
                              pointerEvents: 'none',
                            }}
                          />
                        ) : (
                          <div
                            className="text-center"
                            style={{
                              color: '#fff',
                              fontSize: '0.75rem',
                              padding: '10px',
                            }}
                          >
                            Unknown File
                          </div>
                        )}
                      </a>
                    </div>
                  )
                })}
              </div>
            </CModalBody>

            <CModalFooter
              className=" "
              style={{
                backgroundColor: '#191919',
                borderTop: '1px solid gray',
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                padding: '10px',
                borderRadius: '0 0 10px  10px ',
              }}
            >
              <CButton onClick={() => setShowOrderPopUp(false)} variant="outline" color="secondary">
                Close
              </CButton>
            </CModalFooter>
          </CModal>
        </div>
      </div>
    </>
  )
}

export default ProviderLsSuperBillComponent
